import React, { useState, useEffect } from 'react';
import { Progress } from '@gerdau/hefesto';
import { ProgressContainer } from './style';
import { decodeJwt } from '../../../utils/tokenUtil';
import { RefreshAuthTokenService } from '../../../services/Auth';

interface CountdownTimerProps {
  showTime: (time: number) => void;
  timerHasStopped: boolean;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  showTime,
  timerHasStopped
}) => {
  const refreshAuthTokenService = new RefreshAuthTokenService();
  const securityToken = decodeJwt(
    refreshAuthTokenService.getSecurityToken() ?? ''
  );
  const currentTime = Date.now();
  const timeRemainingSecurityToken =
    (securityToken?.expiration ?? 0) - currentTime;
  const [timeLeft, setTimeLeft] = useState<number>(
    () => timeRemainingSecurityToken
  );
  const totalTime = 300000;

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (timeLeft <= 0) {
      showTime(timeLeft);
      return;
    }

    const interval = timerHasStopped
      ? timeLeft
      : setInterval(() => {
          setTimeLeft((prev) => {
            const newTimeLeft = prev - 1000;
            if (newTimeLeft <= 0) {
              clearInterval(interval);
              return 0;
            }
            return newTimeLeft;
          });
        }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft, timerHasStopped]);

  useEffect(() => {
    const currentProgress = ((totalTime - timeLeft) / totalTime) * 100;
    setProgress(currentProgress);
  }, [timeLeft, totalTime]);

  const formatTime = (milliseconds: number) => {
    const seconds = milliseconds / 1000;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.round(seconds % 60);
    const msgMinutes = minutes < 1 || minutes >= 2 ? 'minutos' : 'minuto';
    const msgSeconds = seconds !== 1 ? 'segundos' : 'segundo';
    return `${String(minutes).padStart(2, '0')} ${msgMinutes} e ${String(
      remainingSeconds
    ).padStart(2, '0')} ${msgSeconds}`;
  };

  return (
    <ProgressContainer>
      <Progress percentNumber={progress} showPercentNumber={false} />
      <span>{formatTime(timeLeft)}</span>
    </ProgressContainer>
  );
};

export default CountdownTimer;
